<template>
	<div class="card card-accent-success mb-3">
		<div class="card-header px-3 py-2">
			<i class="far fa-list-alt fa-lg mr-2"></i>
			{{ __('translations.title.general_info') }}
		</div>
		<div class="card-body p-3">
			<div v-if="success" class="alert alert-success">
				{{ __('translations.message.saved') }}
			</div>
			
			<form @submit.prevent="save" autocomplete="off">
				<input type="hidden" name="image_id" id="image_id" v-model="image.id" />

				<div class="form-group row">
					<label for="title" class="col-sm-3 col-form-label col-form-label-sm pr-0">{{ __('translations.label.title') }}</label>
					<div class="col-sm-9">
						<input type="text" class="form-control form-control-sm" name="title" id="title" v-model="image.title"/>
						<div v-if="errors && errors.title" class="text-danger"><small>{{ errors.title[0] }}</small></div>
					</div>
				</div>
				
				<div class="form-group row">
					<label for="date" class="col-sm-3 col-form-label col-form-label-sm pr-0">{{ __('translations.label.date') }}</label>
					<div class="col-sm-9">
						<div class="input-group">
							<div class="input-group-prepend">
								<div class="input-group-text"><i class="far fa-calendar-alt"></i></div>
							</div>
							<input type="tel" placeholder="YYYY-MM-DD" v-model="image.date" class="form-control form-control-sm" v-mask="'####-##-##'" />
						</div>
						<div v-if="errors && errors.date" class="text-danger"><small>{{ errors.date[0] }}</small></div>
					</div>
				</div>

				<div v-for="property in image.properties" :key="property.id" class="form-group row">
					<label for="title" class="col-sm-3 col-form-label col-form-label-sm pr-0">{{ __('translations.label.' + property.property_name) }}</label>
					<div class="col-sm-9">
						<input type="text" class="form-control form-control-sm" :name="property.property_name" :id="property.property_name" v-model="property.property_value"/>
					</div>
				</div>
				
				<div class="row">
					<div class="col-sm-3 pr-0"></div>
					<div class="col-sm-9">
						<button type="submit" class="btn btn-sm btn-success">{{ __('translations.button.save') }}</button>
						<button type="button" class="btn btn-sm btn-secondary ml-2" @click="cancel">{{ __('translations.button.cancel') }}</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import FormMixin from '../mixins/FormMixin';
import {mask} from 'vue-the-mask'

export default {
	name: 'ImageInfo',
	mixins: [FormMixin],
	directives: {mask},
	props: ['image'],
	data() {
		return {
			action: '/saveImageInfo',
		}
	},
	mounted() {
		// Keep track of the original image information
		this.cachedImage = JSON.parse(JSON.stringify(this.image));
	},
	methods: {
		save() {
			this.fields.id = this.image.id;
			this.fields.title = this.image.title;
			this.fields.date = this.image.date;
			this.fields.properties = this.image.properties;

			this.submit();

			// TODO: Cache it only if the saving was successful
			// Keep track of the updated image information
			this.cachedImage = JSON.parse(JSON.stringify(this.image));
		},
		cancel() {
			// Return the image data back to its previous state
			Object.assign(this.image, JSON.parse(JSON.stringify(this.cachedImage)));
		}
	}
}
</script>